module.exports = __webpack_public_path__ + "static/media/S2N13-5.89dc99de.svg";